import { useNavigate } from 'react-router-dom';
import { useAuthStore } from '../stores/authStore';

export default function Banned() {
  const { banInfo, clearBan } = useAuthStore();
  const navigate = useNavigate();

  const isIndefinite = !banInfo?.bannedUntil;
  const until = banInfo?.bannedUntil ? new Date(banInfo.bannedUntil) : null;

  const handleBackToLogin = () => {
    clearBan();
    navigate('/');
  };

  return (
    <div className="hero">
      <h1 style={{ color: '#ef4444' }}>ACCESS DENIED</h1>
      <p>Your account has been suspended. You cannot access the game.</p>

      <div
        className="card"
        style={{ maxWidth: '520px', margin: '2rem auto', borderColor: '#7f1d1d' }}
      >
        <div className="card-header">
          <h2 className="card-title" style={{ color: '#ef4444' }}>Account Banned</h2>
        </div>

        <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem', textAlign: 'left' }}>
          <div>
            <div style={{ color: '#888', fontSize: '0.75rem', textTransform: 'uppercase', letterSpacing: '0.05em', marginBottom: '0.25rem' }}>
              Reason
            </div>
            <div style={{ color: '#e0e0e0', fontFamily: 'monospace' }}>
              {banInfo?.reason?.trim() ? banInfo.reason : 'No reason provided.'}
            </div>
          </div>

          <div>
            <div style={{ color: '#888', fontSize: '0.75rem', textTransform: 'uppercase', letterSpacing: '0.05em', marginBottom: '0.25rem' }}>
              Banned until
            </div>
            <div style={{ color: '#e0e0e0', fontFamily: 'monospace' }}>
              {isIndefinite ? (
                <span style={{ color: '#ef4444' }}>Indefinite — this ban has no expiry.</span>
              ) : (
                <>
                  {until?.toLocaleString()}{' '}
                  <span style={{ color: '#666' }}>
                    ({until?.toISOString().slice(0, 16).replace('T', ' ')} UTC)
                  </span>
                </>
              )}
            </div>
          </div>
        </div>

        <button
          className="primary"
          style={{ width: '100%', marginTop: '1.5rem' }}
          onClick={handleBackToLogin}
        >
          Back to login
        </button>
      </div>
    </div>
  );
}
